import React from 'react';

interface MenuTriggerIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const MenuTriggerIcon: React.FC<MenuTriggerIconProps> = ({
  width = 16,
  height = 16,
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="8" cy="3" r="1.5" fill="currentColor" />
    <circle cx="8" cy="8" r="1.5" fill="currentColor" />
    <circle cx="8" cy="13" r="1.5" fill="currentColor" />
  </svg>
);
